import React from 'react';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  showText = true, 
  color = '#ffffff' 
}) => {
  const getSize = () => {
    switch (size) {
      case 'small': return { width: 32, height: 32, fontSize: '0.875rem' };
      case 'large': return { width: 64, height: 64, fontSize: '1.5rem' };
      default: return { width: 48, height: 48, fontSize: '1.25rem' };
    }
  };

  const { width, height, fontSize } = getSize();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Logo Icon */}
      <Box
        component="img"
        src="/logo.jpg"
        alt="Triveni Logo"
        sx={{
          width,
          height,
          borderRadius: 2,
          objectFit: 'contain',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      />
      
      {/* Logo Text */}
      {showText && (
        <Typography
          sx={{
            color,
            fontWeight: 700,
            fontSize: fontSize,
            fontFamily: '"Inter", sans-serif',
            letterSpacing: '0.5px',
          }}
        >
          Triveni Admin
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
